<template>
  <div class="image-loading-spinner">
    <p class="loading-title">Loading model…</p>
    <div class="spinner">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageLoader',
};
</script>

<style>
.image-loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.loading-title {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: #666;
}

@media (prefers-color-scheme: dark) {
  .loading-title {
    color: #aaa;
  }
}

.spinner {
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  border: 0.35rem solid #e0e0e0;
  border-top-color: #42b983;
  animation: spinner 0.8s linear infinite;
}

@media (prefers-color-scheme: dark) {
  .spinner {
    border-color: #333;
    border-top-color: #42b983;
  }
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

</style>
